import React, { useMemo, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { ToastContainer } from "react-toastify";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "./components/toastComponent/ToastComponent.scss";
import { keycloak } from "./services/keycloak";
import AppRouter from "./AppRouter";
import "./css/common.scss";
import { ValueProvider } from "./utils/contextAPI/contextAPI";
import { eDetail } from "./utils/constants";
import { useEffect } from "react";
import LogoutModal from "./components/template/logoutTemplate";
import LogInModal from "./components/template/loginTemplate";
import config from "./config";
import axios from "axios";

function App() {
  const [deckId, setDeckId] = useState(null);
  const [userSub, setUserSub] = useState(null);
  const [devices, setDevices] = useState([]);
  const [dimensions, setDimensions] = useState([]);
  const [edetailName, setEdetailName] = useState("");
  const [scheduleLogoutTimer, setScheduleLogoutTimer] = useState(null)
  const [sessionExpiredPopup, setSessionExpiredPopup] = useState(false)
  
  function decodeToken(token) {
    try {
      const decoded = JSON.parse(atob(token.split('.')[1]));
      return decoded;
    } catch (error) {
      return null;
    }
  }

  const saveInLocalStorage = () => {
    const parsed = keycloak.tokenParsed;
    localStorage.setItem("userToken", keycloak.token);
    localStorage.setItem("refreshToken", keycloak.refreshToken);
    localStorage.setItem("idToken", keycloak.idToken)
    localStorage.setItem("userRole", JSON.stringify(parsed.realm_access.roles));
    localStorage.setItem("userEmail", parsed.email);
    localStorage.setItem("userId", parsed.sub);
    localStorage.setItem("currentUserName", parsed.name);
    localStorage.setItem('timeSkew', keycloak.timeSkew)
    localStorage.setItem("sessionState", parsed.session_state)
  }
  
  const storeUserSession = () => {
    const sessionState = localStorage.getItem("sessionState")
    const token = localStorage.getItem("userToken")

    if(sessionState && token){
      if(sessionState !== keycloak.tokenParsed.session_state){
        localStorage.clear()
      }else {
        const payload = decodeToken(token)
        if(payload){
          const exp = payload?.exp
          const now = Math.floor(Date.now() / 1000);
          if(now > exp) {
            setSessionExpiredPopup(true)
            return
          }
          if(now < exp) return
        }
      }    
    }

    saveInLocalStorage()
  }

  const eventLogger = (event) => {
    //  console.log(`Keycloak event triggered ---> ${event}`)
    switch (event) {
      
      case "onReady":
      case "onAuthSuccess":
        storeUserSession()
        scheduleLogoutTimer()
        break;

      case "onAuthRefreshSuccess":
        saveInLocalStorage()
        scheduleLogoutTimer()
        break;

      default:
        break;
    }
  }

  const getValidTokens = () => {
    const token = localStorage.getItem("userToken");
    const refreshToken = localStorage.getItem("refreshToken");
    const idToken = localStorage.getItem("idToken");
    const timeSkew = localStorage.getItem("timeSkew")

    if (!token) return {};
    
    try {
      const payload = decodeToken(token)
      
      if(!payload) return {}

      const now = Math.floor(Date.now() / 1000);
      const exp = payload?.exp
      
      if (now > exp) {
        return {}; 
      }

      return {
        token: token || undefined,
        refreshToken: refreshToken || undefined,
        idToken: idToken || undefined,
        timeSkew: timeSkew ? parseInt(timeSkew) : undefined
      };
    } catch (e) {
      return {};
    }
  };

  const initOptions = useMemo(() => ({
    onLoad: "login-required",
    redirectUri: window.location.origin,
    ...getValidTokens()
  }), [])
  
  return (
    <div className="App">
      <ToastContainer />
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={initOptions}
        onEvent={eventLogger}
        keycloak={keycloak}
        autoRefreshToken={false}
      >
        <ValueProvider
          value={{
            deckId: deckId,
            setDeckId: setDeckId,
            setEdetailName: setEdetailName,
            edetailName: edetailName,
            userSub: userSub,
            setUserSub: setUserSub,
            devices: devices,
            setDevices: setDevices,
            dimensions: dimensions,
            setDimensions: setDimensions,
          }}
        >
          <AppRouter />
          <LogoutModal register={setScheduleLogoutTimer} registerExpiryPopup={setSessionExpiredPopup} decodeToken={decodeToken} />
          <LogInModal setSessionExpiredPopup={setSessionExpiredPopup} sessionExpiredPopup={sessionExpiredPopup}/>
        </ValueProvider>
      </ReactKeycloakProvider>
      <div className="flickeringcol1">
        <span className="flickeringcol2"></span>
        <span className="flickeringcol3"></span>
        <span className="flickeringcol4"></span>
        <span className="flickeringdiv"></span>
        <span className="flickeringHeading"></span>
        <span className="flickeringSubHeading"></span>
        <span className="flickeringPara"></span>
        <span className="flickeringImage"></span>
        <span className="flickeringvideo"></span>
        <span className="flickeringtable"></span>
        <span className="flickeringtabs"></span>
        <span className="flickeringButton"></span>
        <span className="flickeringLink"></span>
        <span className="flickeringform"></span>
        <span className="flickeringLink"></span>
      </div>
    </div>
  );
}

export default App;
